export default "__VITE_PUBLIC_ASSET__5f02bed2__"